var styles = {"input":"styles_input__Xmr2y","errored":"styles_errored__jOgV0","dark":"styles_dark__iY0Mu","suggestions":"styles_suggestions__Zh3rx"};

export { styles as default };
//# sourceMappingURL=styles.css.js.map
